import React, {useEffect} from 'react'

import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import 'moment/locale/es';

// Components

import SectionHeading from '../../../../UI/SectionHeading/SectionHeading';
import RadioInput from '../../../../UI/FormInput/RadioInput';
import Button from '../../../../UI/Button/Button';
import Alert from '../../../../UI/Alert/Alert';


export default function IncomeDeclaration({formik, formStep, setFormStep}) {
    // Dropdown Options
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);
    const dispatch = useDispatch();

    // useEffect(() => {
    //     if (!['1', '2', '6'].includes(formik.values?.cliente?.tipoCliente)) {
    //         formik.handleSubmit();
    //     }
    // }, [])

    const getLocalityName = (localitiesData, localityId) => {
        const code = localityId;
        const item = localitiesData?.find((item) => item.value === code);
        
        return item?.name;
    }

    const getNationalityName = (localitiesData, nationalityId) => {
        const code = nationalityId;
        const item = localitiesData?.find((item) => item.value === code);
        
        return item?.nationality;
    }

    return (
    <>
        <SectionHeading text={'Declaración jurada de no poseer cuenta en ninguna institución bancaria'} />
        {['1', '2', '6'].includes(formik.values?.cliente?.tipoCliente) &&
        <>
            {formik.values?.hasBankReference === 'si' &&
            <RadioInput
                formik={formik}
                fieldName={'hadBankAccount'}
                label={'¿Posee cuenta bancaria?'}
                options={[{label: 'Sí', value: 'si'},{label: 'No', value: 'no'},]}
                isGroup={true}
                isRequired={true}
            />}

            {formik.values?.hasBankReference === 'no' &&
            <div className='inline-text-box'>
                <p>Yo <strong>{formik.values?.cliente?.nombre} {formik.values?.cliente?.primerApellido} {formik.values?.cliente?.segundoApellido}</strong>, de nacionalidad <strong>{getNationalityName(dropDownOptions?.data?.countries, formik.values.cliente?.nacionalidad)}</strong> titular de la cédula de identidad o pasaporte <strong>{formik.values?.cliente?.tipoDocumento === 'P' ? formik.values?.cliente?.tipoDocumento + formik.values?.cliente?.pasaporte : formik.values?.cliente?.tipoDocumento + formik.values?.cliente?.cedulaRif}</strong>, domiciliado en la ciudad de <strong>{getLocalityName(dropDownOptions?.data?.cities, formik.values.cliente?.ciudadNacimiento)}</strong>; declaro bajo fe de juramento que <strong>NO POSEO CUENTA EN NINGUNA INSTITUCIÓN BANCARIA</strong> y que los fondos que se movilizarán en la cuenta abierta en el <strong>BANCO DEL CARIBE C.A, BANCO UNIVERSAL (BANCARIBE)</strong> son de origen y destino lícito, provenientes de actividades realizadas con estricto apego a la ley, dando cumplimiento a la normativa legal actual aplicable, relacionada con la Prevención de delitos de Delincuencia Organizada, Legitimación de Capitales, Financiamiento al Terrorismo y Financiamiento de la Proliferación de Armas de Destrucción Masiva y demás leyes vigentes.</p>

                <p>Declaración que se realiza en la ciudad de <strong>{getLocalityName(dropDownOptions?.data?.cities, formik.values.cliente?.ciudadNacimiento)}</strong>, el <strong>{moment().format('DD [de] MMMM [del] YYYY')}</strong>.</p>
            </div>}

            {formik.values?.hasBankReference === 'no' &&
            <RadioInput
                formik={formik}
                fieldName={'declaration'}
                label={'Si, he leido y acepto esta declaración'}
                options={[{label: 'Sí', value: 'si'}]}
                isGroup={true}
                isSingleRadioInput={true}
                isRequired={true}
            />}
        </>}

        {!['1', '2', '6'].includes(formik.values?.cliente?.tipoCliente) &&
            <Alert text={'Puedes continuar'} />
        }

        <div className='form-actions'>

            <Button
                action={() => dispatch(setFormStep(formStep - 1))}
                label={'Regresa'}
                secondaryStyle={true}
            />

            <Button
                type="submit"
                action={formik.handleSubmit}
                label={'Continua'}
            />

        </div>
    </>
  )
}
